import React, { createContext, useContext, useState, ReactNode } from "react";

export interface UseApiActivityReturn {
  isActive: boolean;
  beginActivity: (key: string) => void;
  endActivity: (key: string) => void;
}

const ApiActivityContext = createContext<UseApiActivityReturn | null>(null);

export const ApiActivityProvider = ({ children }: { children: ReactNode }) => {
  const [counters, setCounters] = useState<Record<string, number>>({});

  const isActive = Object.values(counters).some((n) => n > 0);

  const beginActivity = (key: string) => {
    setCounters((prev) => ({ ...prev, [key]: (prev[key] ?? 0) + 1 }));
  };

  const endActivity = (key: string) => {
    setCounters((prev) => {
      const current = prev[key] ?? 0;
      const next = Math.max(0, current - 1);
      return { ...prev, [key]: next };
    });
  };

  return (
    <ApiActivityContext.Provider value={{ isActive, beginActivity, endActivity }}>
      {children}
    </ApiActivityContext.Provider>
  );
};

export const useApiActivity = (): UseApiActivityReturn => {
  const ctx = useContext(ApiActivityContext);
  if (!ctx) {
    throw new Error("useApiActivity must be used within ApiActivityProvider");
  }
  return ctx;
};
